import styled from "styled-components";

export const StyledButton = styled.button`
  background-color: #4caf50;
  border: none;
  color: white;
  padding: 0.8rem;
  margin: 20px;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  :hover {
    background-color: aquamarine;
    cursor: pointer;
  }
`;
